import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import { CARD_HEIGHT } from '../../Calendar.constants';
import { $calendar } from '../../Calendar.store';
import AppointmentCard from '../../cards/appointmentCard/AppointmentCard';
import OfficeCard from '../../cards/officeCard/OfficeCard';
import PracticeCard from '../../cards/practiceCard/PracticeCard';
import ShiftCard from '../../cards/shiftCard/ShiftCard';
import TravelCard from '../../cards/travelCard/TravelCard';
import styles from './TableColumn.module.scss';
const TableColumn = ({ date, data }) => {
    const maxRows = $calendar.timeLimits.endIndex - $calendar.timeLimits.startIndex;
    return (_jsx("div", Object.assign({ className: styles.column, style: {
            gridTemplateColumns: `repeat(${data.maxCols}, 1fr)`,
            gridTemplateRows: `repeat(${maxRows}, ${CARD_HEIGHT}px)`,
        } }, { children: Object.entries(data.cards).map(([id, item]) => item.type === 'appointment' ? (_jsx(AppointmentCard, { date: date, data: item }, id)) : item.type === 'travel' ? (_jsx(TravelCard, { date: date, data: item }, id)) : item.type === 'practice' ? (_jsx(PracticeCard, { date: date, data: item }, id)) : item.type === 'office' ? (_jsx(OfficeCard, { date: date, data: item }, id)) : (item.type === 'shift' && _jsx(ShiftCard, { date: date, data: item }, id))) })));
};
export default observer(TableColumn);
